import * as React from "react"
import {ReactElement, useState} from "react"
import {RouteComponentProps} from "react-router-dom"
import {H3Text} from "../../styles/AvantTypography"
import {SUPPORT_EMAIL} from "../../util/Constants"
import {AvantLogo} from "../common/AvantLogo"
import MultipleTakes from "./MultipleTakes"
import ProcessingTake from "./ProcessingTake"

import {Grid, Paper} from "@material-ui/core"

export interface VerificientLogin {
    username: string,
    password: string,
    loginId?: number,
    takeId?: number
}

export const RosterSelectTake: React.FC<RouteComponentProps> = (props) => {
    const loginData: VerificientLogin = {
        username : props.location.state.loginData.username,
        password : props.location.state.loginData.password,
        takeId:  props.location.state.takes[0] ? props.location.state.takes[0].takeId : null
    }

    const handleRedirect = (index: number): void => {
        loginData.takeId = props.location.state.takes[index].takeId
        setComponent(<ProcessingTake loginData={loginData} take={props.location.state.takes[index]}/>)
    }

    const getDefaultComponent = (): ReactElement => {
        let comp = <NoTakes/>
        if (props.location.state.takes.length === 1) {
            comp = <ProcessingTake loginData={loginData} take={props.location.state.takes[0]}/>
        } else if (props.location.state.takes.length >= 1) {
            comp = <MultipleTakes takes={props.location.state.takes} handleSelectedTake={handleRedirect}/>
        }
        return comp
    }
    const [component, setComponent] = useState<ReactElement>(getDefaultComponent())

    return (
        <div style={{marginTop: 8}}>
            <AvantLogo title={"Remote Proctoring"}/>
            <div style={{display: "flex", justifyContent: "center"}}>
                <Paper style={{padding: "15px", textAlign: "center"}}>{component}</Paper>
            </div>
        </div>
    )
}

const NoTakes: React.FC = () => {
    return (
        <Grid container={true}>
            <Grid item={true} xs={12}>
                <H3Text>We did not find any active tests for you to take.</H3Text>
            </Grid>
            <Grid item={true} xs={12}>
                <p style={{marginTop: "20px"}}>If you feel that there should be active tests please contact us at
                    &nbsp;<a href={SUPPORT_EMAIL}>{`${SUPPORT_EMAIL}`}</a>
                </p>
            </Grid>
        </Grid>
    )
}
